<template>
  <header
    class="header"
    :class="[
      type ? `header__${type}` : ''
    ]"
  >
    <div
      class="header__top-bar"
      v-if="type !== 'checkout'"
    >
      <header-meta-content />
    </div>
    <div
      class="header__wrapper"
      id="SHOP_HOMEPAGE_BTN"
      ref="wrapperElement"
      :style="{
        height: wrapperElementHeight
      }"
    >
      <div
        class="header__sticky"
        :class="{
          'header__sticky--active': stickyIsActive
        }"
        id="header-sticky"
      >
        <div
          class="header__main"
          :class="[
            type ? `header__main--type_${type}` : ''
          ]"
        >
          <a
            :href="mainHref"
            class="header__logo-link"
            aria-label="Startpage"
          >
            <span
              v-if="logo"
              v-html="logo"
            />
            <img
              v-else
              class="header__logo"
              :alt="logoTitle"
              :title="logoTitle"
              :src="`${baseAssetsUrl}/staticImages/packster_logo.svg`"
              width="180"
              height="40"
              loading="lazy"
            >
          </a>
          <checkout-process-breadcrumbs
            v-if="type === 'checkout'"
            class="header__checkout-process-breadcrumbs"
          />
          <div
            v-if="type !== 'checkout'"
            class="header__user-shortcuts"
          >
            <user-shortcut
              class="header__user-shortcut header__user-shortcut--login"
              id="USER_LOGIN_BTN"
              type="login"
              :active="customer.loggedIn"
              :label="$t('global.account')"
              :url="loginPageUrl"
              :show-badge="false"
            />
            <user-shortcut
              class="header__user-shortcut header__user-shortcut--contact"
              id="CONTACT_BTN"
              type="contact"
              :active="true"
              :label="$t('global.contact')"
              :url="$t('global.contact.url')"
              :show-badge="false"
            />
            <user-shortcut
              class="header__user-shortcut header__user-shortcut--cart"
              id="SHOPPING_BASKET_BTN"
              type="cart"
              :active="basketCount > 0"
              :label="$t('global.cart')"
              :url="basketPageUrl"
              :show-badge="true"
              :badge-count="basketCount"
            />
          </div>
          <span
            v-if="type !== 'checkout'"
            class="header__burger-menu-trigger"
            @click="burgerMenuTriggerClick"
          />
          <div class="header__search">
            <search-autosuggest
              v-if="type !== 'checkout'"
              class="header__search-autosuggest"
              id="SEARCH_FIELD"
              :action="searchBaseUrl"
              name="q"
            />
          </div>
          <navigation
            v-if="type !== 'checkout'"
            class="header__navigation"
          />
        </div>
      </div>
    </div>
  </header>
</template>

<script>
  import globalStateComputedMixin from '../../utilities/vueMixins/globalStateComputedMixin/globalStateComputedMixin.js';
  import SearchAutosuggest from '../searchAutosuggest/searchAutosuggest.vue';
  import Minicart from '../minicart/minicart.vue';
  import Navigation from '../navigation/navigation.vue';
  import HeaderMetaContent from '../headerMetaContent/headerMetaContent.vue';
  import UserShortcut from '../userShortcut/userShortcut.vue'
  import CheckoutProcessBreadcrumbs from '../checkoutProcessBreadcrumbs/checkoutProcessBreadcrumbs.vue';
  import dataLayerMixin from "../../utilities/vueMixins/dataLayerMixin/dataLayerMixin";

  export default {
    mixins: [
      globalStateComputedMixin,
      dataLayerMixin
    ],
    components: {
      SearchAutosuggest,
      HeaderMetaContent,
      Navigation,
      Minicart,
      UserShortcut,
      CheckoutProcessBreadcrumbs
    },
    props: {
      type: String,
      stickyEnabled: {
        type: Boolean,
        default: true
      },
      logo: String
    },
    data() {
      return {
        stickyIsActive: false,
        wrapperElementHeight: '',
      };
    },
    mounted() {
      const trackingData = {
        event: 'eec.generic_data',
        pageType: this.pageType,
        customer: this.customer.loggedIn ? this.getCustomer() : {},
        cartItems: this.cartContent
      };
      if (this.pageType === 'search_results') {
        trackingData.searchTerm = this.searchTerm;
      }
      this.trackEvent(trackingData);

      if (this.stickyEnabled) {
        this.headerStickyToggler();
        window.addEventListener('scroll', this.headerStickyToggler.bind(this));
      }
    },
    methods: {
      headerStickyToggler() {
        const windowScrollPos = window.pageYOffset;

        if (windowScrollPos > this.$refs.wrapperElement.offsetTop && !this.stickyIsActive) {
          this.activateStickyPos();
        } else if (windowScrollPos <= this.$refs.wrapperElement.offsetTop && this.stickyIsActive) {
          this.deactivateStickyPos();
        }
      },
      activateStickyPos() {
        this.stickyIsActive = true;
        this.wrapperElementHeight = `${this.$refs.wrapperElement.offsetHeight}px`;
      },
      deactivateStickyPos() {
        this.stickyIsActive = false;
        this.wrapperElementHeight = '';
      },
      burgerMenuTriggerClick() {
        this.$store.dispatch('toggleBurgerMenu');
      },
      getCustomer() {
        let customer = {};
        customer.email = this.customer.email
        customer.id = this.customer.customerId
        return customer;
      }
    }
  };

</script>
